/** First physical copy Rs 100; each additional copy +Rs 50. */
export const FIRST_COPY_DELIVERY_PKR = 100;
export const EXTRA_COPY_DELIVERY_PKR = 50;

export function physicalDeliveryChargesPkr(copyCount) {
  const n = Math.max(0, Math.floor(Number(copyCount) || 0));
  if (n <= 0) return 0;
  return FIRST_COPY_DELIVERY_PKR + (n - 1) * EXTRA_COPY_DELIVERY_PKR;
}
